import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleSignInToggle } from "./GoogleSignInToggle";
import { OwcButton } from "@one/react";

const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
type GoogleAuthProps = {
  showCalendarIcon?: boolean;
};

export const GoogleAuth = ({ showCalendarIcon }: GoogleAuthProps) => {
  if (!REACT_APP_GOOGLE_CLIENT_ID) {
    console.error("REACT_APP_GOOGLE_CLIENT_ID is not set");
    return (
      <OwcButton disabled placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        No Google auth client ID error
      </OwcButton>
    );
  }

  return (
    <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID}>
      <GoogleSignInToggle showCalendarIcon={showCalendarIcon} />
    </GoogleOAuthProvider>
  );
};
